import { useLocation } from "@reach/router"
import { Fragment, useState } from "react"

import { Button, Container, Dialog, Logo } from "@trueskin-web/components"
import { useThemeUI } from "@trueskin-web/theme"
import { Routes, useTranslation } from "@trueskin-web/translations"

const disableSeparatorUrls = [
  Routes.App.Start.Questionnaire.url,
  Routes.App.Start.CreateAccount.url,
]

const unregisteredUserUrls = [
  Routes.App.Start.Questionnaire.url,
  Routes.App.Start.CreateAccount.url,
]

const HeaderLogo = ({ onClick }) => (
  <Button
    variant="link"
    size="sm"
    onClick={onClick}
    sx={{
      flex: "none",
      p: 0,
    }}
  >
    <Logo size="xsm" />
  </Button>
)

const Header = ({ enableConfirmation }) => {
  const { t } = useTranslation()

  const location = useLocation()

  const { theme } = useThemeUI()

  const [showAlertDialog, setShowAlertDialog] = useState(false)

  const isStepAfterRegistration = !unregisteredUserUrls.some((url) =>
    location.pathname.includes(url)
  )

  const disableSeparator = disableSeparatorUrls.some((url) =>
    location.pathname.includes(url)
  )

  return (
    <Fragment>
      <header>
        <Container
          sx={{
            maxWidth: "100%",
            minWidth: `min(100%, ${theme.sizes.container}px)`,
            textAlign: "center",
          }}
        >
          <div
            sx={{
              display: "inline-flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 3,
              maxWidth: "100%",
              minWidth: ["100%", `min(100%, ${theme.sizes.element}px)`],
              borderBottom: disableSeparator
                ? undefined
                : [`1px solid ${theme.colors.brandNeutralsMediumGrey}`, "none"],
            }}
          >
            <HeaderLogo
              onClick={() =>
                enableConfirmation
                  ? setShowAlertDialog(true)
                  : window.location.assign(window.location.origin)
              }
            />
          </div>
        </Container>
      </header>

      {showAlertDialog && (
        <Dialog
          title={
            isStepAfterRegistration
              ? t("Start.confirmCancel")
              : t("Start.confirmEnd")
          }
          description={
            isStepAfterRegistration
              ? t("Start.savedDataWarning")
              : t("Start.lostDataWarning")
          }
          onDismiss={() => setShowAlertDialog(false)}
          primaryAction={() => setShowAlertDialog(false)}
          primaryActionLabel={t("Start.cancel")}
          secondaryAction={() => window.location.assign(window.location.origin)}
          secondaryActionLabel={t("Start.quit")}
        />
      )}
    </Fragment>
  )
}

export default Header
